<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('setuprestdayschedule.restdayschedulelist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('columns.valuecode'), value: "valuecode", width: "200px" },
        { text: this.$t('columns.valuedescription'), value: "valuedesc", width: "200px" },
        { text: this.$t('columns.effectivefrom'), value: "startdate", width: "200px" },
        { text: this.$t('columns.effectiveuntil'), value: "enddate", width: "200px" },
        { text: this.$t('columns.patterndescription'), value: "rdaypatterndesc", width: "200px" },
        { text: this.$t('columns.patterncode'), value: "rdaypatterncode", width: "200px" },
       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getScheduleInstructionHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/rdayscheduleinstruction/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          for (let i = 0; i < vm.dataItems.length; i++) {
              if (vm.dataItems[i].startdate) {
                  vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                }

              if (vm.dataItems[i].enddate) {
                  vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                }
          }

          vm.loading = !vm.loading;

        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "rdayscheduleinstructionedit", params: { id: item.id, search: item.search } });
    },

    newRecordHandler() {
      this.$router.push({ name: "rdayscheduleinstructionnew" });
    },
  },

  mounted() {
    this.getScheduleInstructionHandler();
  },
};
</script>